export const getPatientInitCountValues = entityTypes => entityTypes && entityTypes.length ? entityTypes.reduce((seed, val) => {
  if (val) {
    seed[val] = [];
  }

  return seed;
}, {}) : null;
/**
 * [{
  "entitytype": "MM",
  "entitykey": "26382319892",
  "count": "1",
  "patientnumber": '6525
}]
 */

export const getCrossPlatformInitCountValues = (counts, initSeed) => counts && counts.length ? counts.reduce((seed, val) => {
  const {
    entitytype,
    entitykey,
    patientnumber
  } = val;

  if (seed[patientnumber]) {
    if (seed[patientnumber][entitytype]) {
      const arr = seed[patientnumber][entitytype];

      if (arr.length) {
        const newArr = arr.filter(el => el.entitykey !== entitykey);
        newArr.push(val);
        seed[patientnumber][entitytype] = newArr;
      }
    } else {
      seed[patientnumber][entitytype] = [val];
    }
  } else {
    seed[patientnumber] = {};
    seed[patientnumber][entitytype] = [val];
  }

  return seed;
}, initSeed) : null;